import React, { useState, useEffect } from "react";
import Dropdowncomp from "src/components/DropDown/Dropdown";
import { getSite } from "src/apis/complex";
import Grid from "@mui/material/Grid";
import "./SiteMonitorDetail.css";
import SiteMonitoringComponent from "src/components/SiteMonitor/siteMonitoringComponent";
import ItemMonitoring from "src/components/ItemMonitoring/ItemMonitoring";
import { getAllTickets, getAllAlarms } from "src/apis/tickets";
import { useRouteLoaderData, defer } from "react-router-dom";
import {
  countObjectsByBuildingId,
  extractAlarms,
  partitionArray,
  transformObjectToArray,
} from "src/util/utilFunctions";
import { useAlertContext } from "src/hooks/use-alert";

export default function SiteMonitor() {
  const { setAlarmCount, setWarningCount } = useAlertContext();
  const [numAlarm, setNumAlarm] = useState(null);
  const [numWarning, setNumWarning] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [warnings, setWarnings] = useState({});

  const handleSelectedItem = (item) => {
    //passed as props to dropdown comp,
    setSelectedItem(item); // it allows me to set the selected item in the dropdown
  };

  const pageContent = useRouteLoaderData("site-monitor");
  const siteInfo = { site: pageContent.site[0] };
  const alarms = pageContent.site[1];

  useEffect(() => {
    var buildingIds = [];
    if (pageContent.site[0] && pageContent.site[0].buildings.length > 0) {
      for (let i = 0; i < pageContent.site[0].buildings.length; i++) {
        buildingIds.push(pageContent.site[0].buildings[i].id);
      }
    }
    if (alarms && alarms.length > 0) {
      const alarmCount = countObjectsByBuildingId(alarms, "ALARM");
      const warningCount = countObjectsByBuildingId(alarms, "WARNING");
      const buildingAlarmCount = transformObjectToArray(alarmCount);
      const buildingWarningCount = transformObjectToArray(warningCount);
      setAlarmCount(buildingAlarmCount);
      setWarningCount(buildingWarningCount);

      if (buildingIds.length > 0) {
        console.log(buildingIds);
        if (buildingAlarmCount.length > 0) {
          //get total of alarms in site
          const totalAlarms = buildingIds.reduce((sum, buildingId) => {
            const matchingAlarm = buildingAlarmCount.find(
              (alarm) => alarm.buildingId === buildingId
            );
            return sum + (matchingAlarm ? matchingAlarm.alarms : 0);
          }, 0);
          setNumAlarm(totalAlarms);
        } else {
          setNumAlarm(0);
        }
        if (buildingWarningCount.length > 0) {
          //get total num of warnings in the site
          const totalWarnings = buildingIds.reduce((sum, buildingId) => {
            const matchingAlarm = buildingWarningCount.find(
              (alarm) => alarm.buildingId === buildingId
            );
            return sum + (matchingAlarm ? matchingAlarm.alarms : 0);
          }, 0);
          setNumWarning(totalWarnings);
        } else {
          setNumWarning(0);
        }
      } else {
        setNumAlarm(0);
        setNumWarning(0);
      }
    }
  }, []);

  let RenderedComponent;
  let componentProps = {};
  switch (selectedItem && selectedItem.type) {
    case "building":
      RenderedComponent = SiteMonitoringComponent;
      componentProps = {
        buildings: siteInfo.site.buildings,
        buildingId: selectedItem.id,
      };
      break;
    case "asset":
      RenderedComponent = ItemMonitoring;
      componentProps = { assetId: selectedItem.id };
      break;
    case "item":
      RenderedComponent = ItemMonitoring;
      componentProps = {};
      break;
    default:
      RenderedComponent = SiteMonitoringComponent;
      componentProps = {
        buildings: siteInfo.site.buildings,
        siteAlarms: { alarms: numAlarm, warnings: numWarning },
      };
      break;
  }

  return (
    <div>
      <h2>Monitoring and Control</h2>
      <div>
        <Grid container>
          <Grid md={3} lg={3} sm={12} xs={12}>
            <Dropdowncomp
              handleSelectedItem={handleSelectedItem}
              props={siteInfo.site}
            />
          </Grid>

          <Grid md={9} lg={9} sm={12} xs={12}>
            {RenderedComponent && <RenderedComponent props={componentProps} />}
          </Grid>
        </Grid>
      </div>
      <div></div>
    </div>
  );
}

async function loadSite(id) {
  const site = await getSite(id);
  const Tickets = await getAllAlarms();
  return [site, Tickets];
}

//this is the loader function which is imported in the app.js and
//passed to the component where i want in the app.js tree
export async function loader({ request, params }) {
  const siteId = params.siteId;
  return defer({
    site: await loadSite(siteId),
  });
}
